import React from 'react';
const INK = '#01332b';
const SKIN = '#FBF7F0';
const BLUE = '#A1D4FD';
interface FigureProps {
  className?: string;
}
export function MiddleChildFigure({
  className = ''
}: FigureProps) {
  return <svg viewBox="0 0 120 148" className={className} role="img" aria-label="Stylised illustration of a balanced, easygoing middle child" data-id="element-28" data-mp="3820jk8252j9v">
      {/* balance plank */}
      <path d="M22 133 L98 139" stroke={INK} strokeWidth="3" strokeLinecap="round" data-id="element-29" data-mp="3hz59miz3uyvy" />
      <path d="M60 126 l8 10 h-16 z" fill={BLUE} stroke={INK} strokeWidth="2.4" data-id="element-30" data-mp="3d0u1ccogkwfu" />

      <g transform="rotate(-5 60 90)" data-id="element-31" data-mp="3d2y1cjj8lbau">
        {/* arms out, balancing */}
        <path d="M42 82 L20 74" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-32" data-mp="3qzjy1r7d8u3o" />
        <path d="M78 82 L100 90" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-33" data-mp="3n02p2nsqdetr" />

        {/* legs — one straight, one relaxed */}
        <path d="M52 118 v16" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-34" data-mp="1wo56r5ypimlt" />
        <path d="M68 118 l6 9 l7 3" stroke={INK} strokeWidth="7" strokeLinecap="round" fill="none" data-id="element-35" data-mp="1smjpz9j1xo6c" />

        {/* torso */}
        <rect x="40" y="72" width="40" height="48" rx="16" fill={BLUE} stroke={INK} strokeWidth="3" data-id="element-36" data-mp="1u4xkm8i37skv" />
        <path d="M60 80 v16" stroke={INK} strokeWidth="2.4" strokeLinecap="round" opacity="0.5" data-id="element-37" data-mp="1z27f42kc2ufk" />

        {/* head */}
        <circle cx="60" cy="52" r="16" fill={SKIN} stroke={INK} strokeWidth="3" data-id="element-38" data-mp="28tkav59964qv" />
        <path d="M44 50 q1 -18 16 -18 q15 0 16 18 q-4 -7 -10 -8 q-8 5 -16 2 q-3 2 -6 6 z" fill={INK} data-id="element-39" data-mp="2cu43pwmsmm77" />
        <circle cx="54" cy="54" r="2.2" fill={INK} data-id="element-40" data-mp="2hsfj0mvuxowt" />
        <circle cx="66" cy="54" r="2.2" fill={INK} data-id="element-41" data-mp="2msjws55ds5jc" />
        <path d="M54 60 q6 5 12 1" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" data-id="element-42" data-mp="2mr8u68no93tt" />
      </g>
    </svg>;
}